<template>
  <div>
    <v-text-field
      v-model="formData.kv"
      label="KV"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="generateInfoBL"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading Data
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading && data.kv"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h2 class="report-title">
            {{ companyName }} - Info Data Bill of Landing
          </h2>
          <div class="report-info">
            <div class="vessel">
              <p>
                Vessel: <b>{{ data.vessel }}</b>
              </p>
            </div>
            <div class="kv">
              <div>{{ data.kv }}</div>
            </div>
            <div class="tgl">
              <p>
                Tgl Berangkat: <b>{{ tgl_berangkat }}</b>
              </p>
            </div>
          </div>
        </div>
      </div>

      <table width="100%" class="mb-2">
        <thead>
          <th>Shiper u/ Consignee</th>
          <th></th>
          <th>No Cont</th>
          <th>Seal</th>
          <th>Cargo</th>
          <th>Tujuan</th>
        </thead>
        <tbody>
          <tr v-for="container in data.container" :key="container.id">
            <td>{{ container.bl || "-" }}</td>
            <td>{{ container.jenis_container }}</td>
            <td>{{ container.no_container }}</td>
            <td>{{ container.no_seal }}</td>
            <td>{{ container.cargo }}</td>
            <td>{{ container.port_tujuan }}</td>
          </tr>
        </tbody>
      </table>

      <footer>
        <div class="total">
          <h3>Total Container: {{ data.container.length }}</h3>
          <h3>Total B/L: {{ data.total_bl }}</h3>
        </div>
        <div class="sign">
          <p>Hormat Kami,</p>
        </div>
      </footer>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.kv"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
import variableMixin from "@/mixins/variableMixin";

export default {
  mixins: [variableMixin],
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      formData: {
        kv: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    tgl_berangkat() {
      let date = new Date(this.data.tgl_berangkat);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  },
  watch: {
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async generateInfoBL() {
      this.state.loading = true;

      await axios
        .get(`laporan/info-data-bl?kv=${this.formData.kv}`)
        .then(res => {
          if (!res.data.kv) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header .left {
  width: 100%;
}

.header .right {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right p {
  font-size: 12px;
}

.report-info {
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
}

.report-info p {
  font-style: italic;
}

.report-info .kv {
  padding: 0 5px;
  height: fit-content;
  border: 1px solid black;
}

table {
  border-bottom: 1px solid black;
}

table th {
  text-align: left;
}

footer {
  display: flex;
  justify-content: space-between;
}

.sign p {
  margin-right: 150px;
}
</style>
